import { render, staticRenderFns } from "./IndexDefault.vue?vue&type=template&id=8de7c052"
import script from "./IndexDefault.vue?vue&type=script&lang=js"
export * from "./IndexDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports